import { Person } from './person';
import { Company } from './company';
import { EmployeeDoc } from './employeeDoc';

export class Employee extends Person {
  hiringDate: Date = null;
  subContractorName: string = null;
  hiringCommunication: string = null;
  workPermit: string = null;
  durc_code: string = null;
  contractNumber: string = null;
  typeOfContract: string = null;
  pesticideLicenseNumber: string = null;
  pesticideLicenseDueDate: Date = null;

  company: Company = null;
  attachments: Array<EmployeeDoc> = [];
  badge: string = null;
  typeBadge: string = null;
  externalBadges: Array<ExternalBadge> = [];
  roleTMP?: any;
  isPhytosanitaryHandler?: boolean;
  phytosanitaryHandlerLicense?: string;
  ropoRegistrationNumber?: string;
  isFarmAdvisor?: boolean;
  farmAdvisorIdNumber?: string;
  farmAdvisorCompanyType?: string;
  isExternalWorker?: boolean;
  externalCompanyName?: string;
  externalLicenseNumber?: string;
  externalLicenseValidFrom?: Date;
  externalLicenseValidTo?: Date;

  constructor() {
    super();
    this.isPhytosanitaryHandler = null;
    this.phytosanitaryHandlerLicense = null;
    this.ropoRegistrationNumber = null;
    this.isFarmAdvisor = null;
    this.farmAdvisorCompanyType = null;
    this.farmAdvisorIdNumber = null;
    this.isExternalWorker = null;
    this.externalCompanyName = null;
    this.externalLicenseNumber = null;
    this.externalLicenseValidFrom = null;
    this.externalLicenseValidTo = null;
  }
}

export class ExternalBadge {
  badge: string = null;
  typeBadge: string = null;
  externalId: string = null;
  externalSource: string = null;
  constructor() {
    this.badge = null;
    this.typeBadge = null;
    this.externalId = null;
    this.externalSource = null;
  }
}
